import styled from 'styled-components';

export const ReorderContainer = styled.div`
  /* width: fit-content; */
`;

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  :not(:last-child) {
    margin-bottom: 16px;
  }
  div.dragger {
    margin-right: 18px;
    min-width: 8px;
    cursor: grab;
  }
  div.dragger.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
